<template>
  <div class="site">
    <common-layout>
      <div slot="header">
        <h3>金融产品</h3>
      </div>
      <div slot="container">
        <div class="site.header">
          <el-button type="success" class="site.addBtn" @click="openSiteModal('')" v-if="isFinance">
            新增
          </el-button>
          <section>
            <el-input
              placeholder="请输入内容"
              v-model="paramsObj.keyword"
              class="input-with-select"
              clearable
              @change="search"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </section>
        </div>
        <div class="site.table">
          <el-table :data="tableData" stripe style="width: 100%" :header-cell-style="headerStyle">
            <el-table-column
              type="index"
              :index="
                index => {
                  return index + (paramsObj.page - 1) * paramsObj.pageSize + 1;
                }
              "
              label="序号"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="investmentFirmsName"
              label="金融机构名称"
              align="center"
            ></el-table-column>
            <el-table-column prop="name" label="产品名称" align="center"></el-table-column>

            <el-table-column label="行业" align="center" prop="industryName"></el-table-column>
            <el-table-column label="覆盖地域" align="center" prop="areaStr"></el-table-column>

            <el-table-column
              prop="applicableObjects"
              label="产品适用对象"
              align="center"
            ></el-table-column>
            <el-table-column prop="financingAmountMin" label="贷款额度（万元）" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.financingAmountMin }} - {{ scope.row.financingAmountMax }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="financingTermName"
              label="贷款期限"
              align="center"
            ></el-table-column>
            <el-table-column prop="approvalStatus" label="审核状态" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.approvalStatus === 1">待审核</div>
                <div v-if="scope.row.approvalStatus === 2">不通过</div>
                <div v-if="scope.row.approvalStatus === 3">退回</div>
                <div v-if="scope.row.approvalStatus === 4">通过</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="260px">
              <template slot-scope="scope">
                <el-button
                  class="mini_btn"
                  type="text"
                  size="mini"
                  @click="handleDetail(scope.row)"
                >
                  详情
                </el-button>
                <el-button
                  style="margin-bottom: 5px;"
                  size="mini"
                  @click="openSiteModal(scope.row)"
                  v-if="
                    (scope.row.approvalStatus === 1 && isFinance) ||
                      (scope.row.approvalStatus === 3 && isFinance)
                  "
                >
                  编辑
                </el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                  v-if="scope.row.approvalStatus !== 1 && isFinance"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div class="pagination">
            <div class="grid-content bg-purple-light">
              <el-pagination
                @current-change="handleCurrentChange"
                :hide-on-single-page="true"
                layout="total, prev, pager, next,jumper"
                :total="total"
                :current-page.sync="paramsObj.page"
                :page-size="paramsObj.pageSize"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </common-layout>

    <!-- 新增机构 -->
    <el-dialog
      :title="titleDialog"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @closed="is_submit = true"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="机构类型" prop="typeName">
              <!-- <el-input v-model="ruleForm.typeName" placeholder="请输入机构类型" disabled></el-input> -->
              <el-select v-model="ruleForm.orgType" placeholder="请选择机构类型" clearable disabled>
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="item in roleTypeList"
                  :key="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构名称" prop="investmentFirmsName">
              <el-input
                v-model="ruleForm.investmentFirmsName"
                placeholder="请输入机构名称"
                disabled
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="产品名称" prop="name">
              <el-input
                v-model="ruleForm.name"
                placeholder="请输入产品名称"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="行业" prop="industryId">
              <el-select
                v-model="ruleForm.industryId"
                placeholder="请选择行业"
                clearable
                @change="selectChange($event, guaranteeTypeList, 'industryName')"
                :disabled="operationType === 'detail'"
              >
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="item in guaranteeTypeList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="覆盖地域" prop="productSuitableJson">
              <el-select
                v-model="productSuitableArr"
                placeholder="请选择覆盖地域"
                clearable
                multiple
                @change="suitChange"
                :disabled="operationType === 'detail'"
              >
                <el-option
                  v-for="item in areaOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="产品适用对象" prop="applicableObjects">
              <el-input
                v-model="ruleForm.applicableObjects"
                placeholder="请输入产品适用对象"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="产品简介" prop="introduction">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入产品简介"
                v-model="ruleForm.introduction"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="功能特点" prop="features">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入功能特点"
                v-model="ruleForm.features"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="办理条件" prop="handleCondition">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入办理条件"
                v-model="ruleForm.handleCondition"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="申请流程" prop="applyProcess">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入申请流程"
                v-model="ruleForm.applyProcess"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row :span="20">
            <!-- <el-col :span="12"> -->
            <el-form-item label="年化率（%）" prop="numberRange">
              <InputNumberRange
                :precision="2"
                v-model="ruleForm.numberRange"
                :disabled="operationType === 'detail'"
                @input="inputChange($event, 'numberRange')"
              />
            </el-form-item>
            <!-- </el-col>
						<el-col :span="12"> -->
            <el-form-item label="贷款额度（万元）" prop="financeRange">
              <InputNumberRange
                :disabled="operationType === 'detail'"
                :precision="2"
                v-model="ruleForm.financeRange"
                @input="inputChange($event, 'financeRange')"
              />
            </el-form-item>
            <!-- </el-col> -->
          </el-row>
          <el-row>
            <el-form-item label="贷款期限" prop="financingTermId">
              <el-select
                v-model="ruleForm.financingTermId"
                placeholder="请选择贷款期限"
                clearable
                @change="selectChange($event, financingTermList, 'financingTermName')"
                :disabled="operationType === 'detail'"
              >
                <el-option
                  :label="item.label"
                  :value="item.id"
                  v-for="item in financingTermList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                placeholder="请输入联系人"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="contactInformation">
              <el-input
                v-model="ruleForm.contactInformation"
                placeholder="请输入联系方式"
                :disabled="operationType === 'detail'"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="是否发布" prop="publishedFlag" style="text-align:left">
              <el-switch
                v-model="ruleForm.publishedFlag"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="operationType === 'detail'"
              ></el-switch>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="封面图" prop="logo">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                ref="upload0"
                :file-list="logo"
                :limit="limit"
                :before-upload="beforeAvatarUpload"
                :disabled="operationType === 'detail'"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'logo')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="operationType !== 'detail'"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'logo')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="showUpload && operationType !== 'detail'"
                >
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row v-if="operationType === 'detail'">
            <el-form-item label="审核状态" prop="approvalStatus">
              <el-select
                v-model="ruleForm.approvalStatus"
                placeholder="请选择审核状态"
                clearable
                disabled
              >
                <el-option label="待审核" :value="1"></el-option>
                <el-option label="不通过" :value="2"></el-option>
                <el-option label="退回" :value="3"></el-option>
                <el-option label="通过" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="createSite" v-if="operationType !== 'detail'">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import CommonLayout from "../../../components/common-layout.vue";
import InputNumberRange from "../../../components/inputNumberRange";
export default {
  components: {
    CommonLayout,
    InputNumberRange,
  },
  data() {
    return {
      listUrl: `${urlConfig.devUrl}apij2/admin-api/finance/product/page`,
      paramsObj: {
        keyword: "",
        page: 1,
        pageSize: 10,
      },
      financingTermList: [], // 融资期限
      guaranteeTypeList: [],
      roleTypeList: [
        { value: 1, label: "普通用户" },
        { value: 2, label: "管理员" },
        { value: 3, label: "金融机构" },
        { value: 1268, label: "银行" },
        { value: 1269, label: "担保机构" },
        { value: 1270, label: "其他服务机构" },
        { value: 4, label: "投资机构" },
        { value: 5, label: "担保机构" },
      ],
      limit: 1,
      financeRange: [], // 融资额度数组
      numberRange: [],
      productSuitableArr: [], // 覆盖地域
      is_submit: true,
      headerStyle: {
        color: "#623AA2",
        background: "#E5F3FE",
      },
      operationType: "add",
      total: 20,
      dialogFormVisible: false,
      ruleForm: {
        orgType: 0, // 机构类型
        name: "", // 产品名称
        industryId: "", // 行业id
        industryName: "", // 行业名称
        productSuitableJson: "", // 覆盖地域json
        introduction: "", // 产品简介
        features: "", // 功能特点
        handleCondition: "", // 办理条件
        applyProcess: "", // 申请流程
        financingAmountMin: "", // 融资额度最少
        financingAmountMax: "", // 融资额度最多
        financeRange: [], // 融资额度
        annualizedRateMin: "", // 年化率最小
        annualizedRateMax: "", // 年化率最大
        numberRange: [], // 年化率
        financingTermId: "", // 融资期限id
        financingTermName: "", // 融资期限名称
        contactPerson: "", // 联系人
        contactInformation: "", // 联系方式
        approvalStatus: 1, // 审核状态
        creatorCategory: "", // 创建者类别
        publishedFlag: 0, // 是否发布
        dataSrc: 1, // 数据来源
        investmentFirmsId: 0, // 金融机构id
        investmentFirmsName: 0, // 金融机构name
        logo: null,
      },
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
        industryId: [{ required: true, message: "请选择行业", trigger: ["blur", "change"] }],
        productSuitableJson: [
          { required: true, message: "请选择覆盖地域", trigger: ["blur", "change"] },
        ],
        applicableObjects: [{ required: true, message: "请输入产品适用对象", trigger: "blur" }],
        introduction: [{ required: true, message: "请输入产品简介", trigger: "blur" }],
        features: [{ required: true, message: "请输入功能特点", trigger: "blur" }],
        // numberRange: [
        //   {
        //     type: 'array',
        //     required: true,
        //     message: '请输入年化率',
        //     trigger: ['blur', 'change'],
        //     len: 2
        //   }
        // ],
        financeRange: [
          {
            type: "array",
            required: true,
            message: "请输入融资额度",
            trigger: ["blur", "change"],
            len: 2,
          },
        ],
        financingTermId: [
          { required: true, message: "请选择贷款期限", trigger: ["blur", "change"] },
        ],
        contactPerson: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        contactInformation: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        // approvalStatus: [
        // 	{ required: true, message: "请选择审核状态", trigger: ["blur", "change"] }
        // ],
        publishedFlag: [{ required: true, message: "请选择是否发布", trigger: ["blur", "change"] }],
        logo: [{ required: true, message: "请上传封面图", trigger: ["blur", "change"] }],
      },
      tableData: [],
      titleDialog: "",
      logo: [],
      dialogImageUrl: "",
      dialogVisible: false,
      showUpload: false,
      areaOptions: [
        {
          value: "兰州市",
          label: "兰州市",
        },
        {
          value: "嘉峪关市",
          label: "嘉峪关市",
        },
        {
          value: "金昌市",
          label: "金昌市",
        },
        {
          value: "白银市",
          label: "白银市",
        },
        {
          value: "天水市",
          label: "天水市",
        },
        {
          value: "武威市",
          label: "武威市",
        },
        {
          value: "张掖市",
          label: "张掖市",
        },
        {
          value: "酒泉市",
          label: "酒泉市",
        },
        {
          value: "平凉市",
          label: "平凉市",
        },
        {
          value: "庆阳市",
          label: "庆阳市",
        },
        {
          value: "定西市",
          label: "定西市",
        },
        {
          value: "陇南市",
          label: "陇南市",
        },
        {
          value: "临夏回族自治州",
          label: "临夏回族自治州",
        },
        {
          value: "甘南藏族自治州",
          label: "甘南藏族自治州",
        },
      ],
    };
  },
  created() {
    this.getInfo();
    this.getGroup();
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logo: {
      handler() {
        this.checkLimit(this.logo, 0);
      },
    },
  },
  methods: {
    closeDialog() {
      this.dialogFormVisible = false;
      this.logo = [];
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      const uploadDom = this.$refs["upload0"];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = "none";
        this.showUpload = true;
      } else {
        uploadDom.$children[1].$el.style.display = "";
        this.showUpload = false;
      }
    },
    // 获取数据字典
    getGroup() {
      let obj = {
        dictTypes: ["financial_financing_term", "financial_industry"],
      };
      this.http.post(`${urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, obj).then(
        response => {
          if (response.code == 0) {
            console.log("response", response);
            this.financingTermList = response.data.financial_financing_term;
            this.guaranteeTypeList = response.data.financial_industry;
            this.guaranteeTypeList.unshift({ id: 0, label: "不限行业" });
            // this.ruleForm = response.data
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif" ||
        file.type === "image/bmp"
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return type && isLt2M;
    },
    handleRemove(file, fileList, type) {
      this.logo = [];
      this.ruleForm.logo = "";
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this.logo = fileList;

        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name,
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        // if (type === 'logoSrc' || type === 'realImageSrc') {
        //   this.ruleForm[type] = arr[0].url;
        // }
      } else {
        this.ruleForm[type] = "";
        this[type] = [];
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getInfo() {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/system/user/get`).then(
        response => {
          // this.ResetSearch(['searchValue'])

          if (response.code == 0) {
            console.log("response", response);
            this.ruleForm.orgType = response.data.type;
            this.ruleForm.investmentFirmsId = response.data.managerId
              ? response.data.managerId
              : response.data.id;
            this.ruleForm.investmentFirmsName = response.data.managerName
              ? response.data.managerName
              : response.data.name;
            console.log(this.ruleForm);
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    selectChange(e, list, props) {
      if (e !== null && e !== "" && e !== undefined) {
        this.ruleForm[props] = list.find(item => item.id === e).label;
      } else {
        this.ruleForm[props] = "";
      }
      console.log("this.ruleForm[props]", this.ruleForm[props]);
    },
    inputChange(val, props) {
      if (val[0]) {
        this.ruleForm[props][0] = val[0];
      } else {
        delete this.ruleForm[props][0];
        this.ruleForm[props].length = 1;
      }
      if (val[1]) {
        this.ruleForm[props][1] = val[1];
      } else {
        delete this.ruleForm[props][1];
        this.ruleForm[props].length = 1;
      }
      console.log("this.numberRange", this.ruleForm[props]);
    },
    inputFinancefrom(val) {
      this.financeRange[0] = val;
    },
    inputFinanceto(val) {
      this.financeRange[1] = val;
    },
    // 覆盖地域切换
    suitChange(val) {
      console.log(val.length);
      if (val.length > 0) {
        this.ruleForm.productSuitableJson = JSON.stringify(val);
      } else {
        this.ruleForm.productSuitableJson = "";
      }
      console.log("this.ruleForm.productSuitableJson", this.ruleForm.productSuitableJson);
    },
    // 确认添加机构
    createSite() {
      if (!this.is_submit) {
        return;
      }
      this.is_submit = false;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (this.operationType == "add") {
            // delete this.ruleForm.id;
            this.ruleForm.annualizedRateMin = this.ruleForm.numberRange[0] || "";
            this.ruleForm.annualizedRateMax = this.ruleForm.numberRange[1] || "";
            this.ruleForm.financingAmountMin = this.ruleForm.financeRange[0];
            this.ruleForm.financingAmountMax = this.ruleForm.financeRange[1];
            this.ruleForm.publisher = Cookies.get("Admin-Token");

            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/finance/product/create`, this.ruleForm)
              .then(res => {
                if (res.code == 0) {
                  // this.ResetSearch(['searchValue'])

                  this.$message.success("新建成功！");
                  this.getData();
                  this.logo = [];
                  this.dialogFormVisible = false;
                } else {
                  this.is_submit = true;

                  this.$message.error(res.status);
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          } else {
            // 审核-退回的担保机构，修改重置为待审核
            if (this.ruleForm.approvalStatus === 3) {
              this.ruleForm.approvalStatus = 1;
            }
            this.http
              .post(`${urlConfig.devUrl}apij2/admin-api/finance/product/update`, this.ruleForm)
              .then(res => {
                if (res.code == 0) {
                  // this.ResetSearch(['searchValue'])

                  this.$message.success("编辑成功！");
                  this.getData();
                  this.dialogFormVisible = false;
                } else {
                  this.is_submit = true;
                  this.$message.error(res.status);
                }
              })
              .catch(err => {
                this.is_submit = true;
              });
          }
        } else {
          this.is_submit = true;

          console.log("error submit!!");
          return false;
        }
      });
    },
    // 新增、编辑
    openSiteModal(row) {
      this.operationType = row ? "edit" : "add";

      this.titleDialog = this.operationType === "add" ? "新增产品" : "编辑产品";
      this.dialogFormVisible = true;
      this.resetForm();
      this.getInfo();

      this.productSuitableArr = [];
      this.ruleForm.financeRange = [];
      this.ruleForm.numberRange = [];

      if (this.operationType === "edit") {
        this.getDetail(row);
      }
    },
    // 详情
    handleDetail(row) {
      this.titleDialog = "产品详情";
      this.operationType = "detail";
      this.getDetail(row);
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm = {
        orgType: 0, // 机构类型
        name: "", // 产品名称
        industryId: "", // 行业id
        industryName: "", // 行业名称
        productSuitableJson: "", // 覆盖地域json
        introduction: "", // 产品简介
        features: "", // 功能特点
        handleCondition: "", // 办理条件
        applyProcess: "", // 申请流程
        financingAmountMin: "", // 融资额度最少
        financingAmountMax: "", // 融资额度最多
        annualizedRateMin: "", // 年化率最小
        annualizedRateMax: "", // 年化率最大
        financeRange: [], // 融资额度
        numberRange: [], // 年化率
        financingTermId: "", // 融资期限id
        financingTermName: "", // 融资期限名称
        contactPerson: "", // 联系人
        contactInformation: "", // 联系方式
        approvalStatus: 1, // 审核状态
        creatorCategory: "", // 创建者类别
        publishedFlag: 0, // 是否发布
        dataSrc: 1, // 数据来源
        investmentFirmsId: 0, // 金融机构id
        investmentFirmsName: 0, // 金融机构name
      };
    },
    //选择页码
    handleCurrentChange(e) {
      this.paramsObj.page = e;
      this.getData();
    },
    // 获取金融产品详情
    getDetail(row) {
      this.http.get(`${urlConfig.devUrl}apij2/admin-api/finance/product/get?id=${row.id}`).then(
        response => {
          // this.ResetSearch(['searchValue'])

          if (response.code == 0) {
            console.log("response", response);
            this.ruleForm = response.data;
            this.productSuitableArr = response.data.productSuitableJson
              ? JSON.parse(response.data.productSuitableJson)
              : [];
            this.logo = response.data.logo ? JSON.parse(response.data.logo) : [];
            this.ruleForm.financeRange = [];
            this.ruleForm.numberRange = [];
            this.ruleForm.financeRange[0] = response.data.financingAmountMin;
            this.ruleForm.financeRange[1] = response.data.financingAmountMax;
            this.ruleForm.numberRange[0] = response.data.annualizedRateMin;
            this.ruleForm.numberRange[1] = response.data.annualizedRateMax;
          } else {
            this.$message.error(response.status);
          }
        },
        error => {}
      );
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确定删除该产品吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          let obj = {
            ids: [row.id],
          };
          this.http.delete(`${urlConfig.devUrl}apij2/admin-api/finance/product/delete`, obj).then(
            response => {
              // this.ResetSearch(['searchValue'])

              if (response.code == 0) {
                this.$message.success("删除成功！");
                this.paramsObj.page = 1;
                this.getData();
              } else {
                this.$message.error(response.status);
              }
            },
            error => {}
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //搜索
    search() {
      this.getData();
    },
    getData() {
      this.http.post(this.listUrl, this.paramsObj).then(res => {
        if (res.code == 0) {
          let arr = res.data.data;

          arr.forEach(item => {
            item.areaStr =
              item.productSuitableJson && item.productSuitableJson !== ""
                ? JSON.parse(item.productSuitableJson).join(" ; ")
                : "";
            // if(item.productSuitableJson) {
            // 	item.areaStr = JSON.parse(item.productSuitableJson).join(' ; ')
            // }else{
            // 	item.areaStr = ""
            // }
          });
          this.tableData = arr;
          this.total = res.data.total;
        }
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
@include component(site) {
  width: 100%;
  height: 100%;

  @include part(header) {
    display: flex;
    justify-content: flex-start;

    @include component(el-input) {
      width: 300px;
    }
  }

  @include part(searchBtn) {
    margin-left: 10px;
  }

  @include part(addBtn) {
    margin-right: 30px !important;
    background: #623aa2 !important;
    color: #fff;
    border: none;
  }

  @include part(table) {
    margin-top: 30px;
  }

  @include component(rowItem) {
    width: 50%;
  }

  @include component(el-radio-group) {
    width: 100%;
    text-align: left;
  }
  .mini_btn {
    // width: 56px;
    // height: 28px;
    border: 1px solid #409eff;
    border-radius: 3px;
    padding: 7px 15px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }
  .el-select {
    width: 100%;
    margin: 0;
  }
  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }

  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .rowItem1 {
    float: left;
  }
}
</style>
